import { IconCheck } from '@lmn/lastminute-react-icons/lastminute-icons-linear';
import { MenuItem } from '@mui/material';
import styled from 'styled-components';
var MenuItemStyled = /*#__PURE__*/styled(MenuItem).withConfig({
  displayName: "MenuItemstyles__MenuItemStyled",
  componentId: "sc-fguzn7-0"
})(["&.MuiMenuItem-root{background:none;justify-content:flex-start;width:100%;cursor:pointer;position:relative;", " ", " color:", ";&:hover,&:focus{background-color:", ";}&:active{background-color:", ";}&.Mui-selected{background:unset;}&:last-child{", "}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mixins.font('TextLarge');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.mixins.padding({
    hor: 2,
    ver: 1
  });
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.commons.colors.gray800;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.commons.colors.gray50;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.commons.colors.gray100;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.mixins.margin({
    bottom: 1
  });
});
var Label = /*#__PURE__*/styled.span.withConfig({
  displayName: "MenuItemstyles__Label",
  componentId: "sc-fguzn7-1"
})(["", ""], function (_ref7) {
  var theme = _ref7.theme;
  return theme.mixins.margin({
    right: 2
  });
});
var SelectedIcon = /*#__PURE__*/styled(IconCheck).withConfig({
  displayName: "MenuItemstyles__SelectedIcon",
  componentId: "sc-fguzn7-2"
})(["color:", ";visibility:", ";margin-left:auto;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.commons.colors.primary400;
}, function (_ref9) {
  var $isVisible = _ref9.$isVisible;
  return $isVisible ? 'visible' : 'hidden';
});
export var MenuItemStyles = {
  MenuItem: MenuItemStyled,
  Label: Label,
  SelectedIcon: SelectedIcon
};